// Commercial Acoustic Calculator Data
// Based on Google Sheets: Merged Product Calculator Sept 15 2025
window.AcousticCalculatorCommercialData = {
  // Room Types - targetRT60 is calculated dynamically based on room volume
  roomTypes: [
    {
      id: "unamplified_music",
      label: "Unamplified Music, Church",
      lowerLimit: 0.5,
      description: "church, for choral music",
      // Formula: MAX(0.50, (0.44 * LOG(Volume/1000) + 0.72) * 1.2)
    },
    {
      id: "auditorium",
      label: "Auditorium, Multipurpose Room",
      lowerLimit: 0.5,
      description: "concert hall, for classical music",
      // Formula: MAX(0.50, (0.44 * LOG(Volume/1000) + 0.64) * 1.2)
    },
    {
      id: "cafeteria",
      label: "Cafeteria, Lobby, Gymnasium",
      lowerLimit: 0.5,
      description: "church, for speech (lobby or circulation space)",
      // Formula: MAX(0.50, (0.44 * LOG(Volume/1000) + 0.52) * 1.2)
    },
    {
      id: "restaurant",
      label: "Restaurant, Shared Office, Kitchen",
      lowerLimit: 0.5,
      description: "theater (open or shared office or restaurant)",
      // Formula: MAX(0.50, (0.305 * LOG(Volume/1000) + 0.511) * 1.2)
    },
    {
      id: "conference",
      label: "Conference Room, Private Office, Living Space",
      lowerLimit: 0.5,
      description: "conf room and lecture hall (private office, training room)",
      // Formula: MAX(0.50, (0.24 * LOG(Volume/1000) + 0.443) * 1.2)
    },
    {
      id: "critical_audio",
      label: "Critical audio recording and playback, Home Theater",
      lowerLimit: 0.3,
      description: "recording studio (podcast room, home theater)",
      showWarning: true,
      // Formula: MAX(0.30, (0.33 * LOG(Volume/1000) + 0.17) * 1.2)
    },
  ],

  // Frequency bands for calculations
  frequencyBands: ["4000 Hz", "2000 Hz", "1000 Hz", "500 Hz", "250 Hz"],

  // Wall Materials with absorption coefficients.
  // IDs match `docs/acoustic-calculator-sheet-data.yaml` (materials.walls).
  // Legacy IDs ('gypsum', 'cmu', 'concrete') remapped via WALL_ID_MIGRATION in loadSettings.
  wallMaterials: [
    {
      value: "gypsum_plaster",
      label: "Gypsum / Plaster",
      description:
        "Plasterboard on frame, 13 mm boards, 100 mm cavity filled with mineral wool",
      absorption: {
        "4000 Hz": 0.05,
        "2000 Hz": 0.06,
        "1000 Hz": 0.06,
        "500 Hz": 0.08,
        "250 Hz": 0.12,
      },
    },
    {
      value: "brick",
      label: "Brick",
      description: "Smooth brickwork with flush pointing",
      absorption: {
        "4000 Hz": 0.07,
        "2000 Hz": 0.05,
        "1000 Hz": 0.04,
        "500 Hz": 0.03,
        "250 Hz": 0.03,
      },
    },
    {
      value: "concrete_block",
      label: "Concrete Block",
      description: "Concrete block walls, with or without plaster, painted",
      absorption: {
        "4000 Hz": 0.05,
        "2000 Hz": 0.05,
        "1000 Hz": 0.06,
        "500 Hz": 0.07,
        "250 Hz": 0.08,
      },
    },
    {
      value: "solid_concrete",
      label: "Solid Concrete",
      description: "Concrete wall, rough finish",
      absorption: {
        "4000 Hz": 0.03,
        "2000 Hz": 0.02,
        "1000 Hz": 0.02,
        "500 Hz": 0.01,
        "250 Hz": 0.01,
      },
    },
    {
      value: "glass",
      label: "Glass",
      // Sheet updated 4-21-26: window glass (brighter), not heavy glazing.
      description: "Windows, window glass",
      absorption: {
        "4000 Hz": 0.04,
        "2000 Hz": 0.07,
        "1000 Hz": 0.12,
        "500 Hz": 0.18,
        "250 Hz": 0.25,
      },
    },
    {
      value: "ceramic_tiles",
      label: "Ceramic Tiles",
      description: "Marble or glazed tile",
      absorption: {
        "4000 Hz": 0.02,
        "2000 Hz": 0.02,
        "1000 Hz": 0.01,
        "500 Hz": 0.01,
        "250 Hz": 0.01,
      },
    },
    {
      value: "wood_paneling",
      label: "Wood Paneling",
      description: 'Wood paneling on studs, <1/2" thick',
      absorption: {
        "4000 Hz": 0.1,
        "2000 Hz": 0.09,
        "1000 Hz": 0.09,
        "500 Hz": 0.17,
        "250 Hz": 0.24,
      },
    },
  ],

  // Ceiling Materials — IDs match docs/acoustic-calculator-sheet-data.yaml (materials.ceilings).
  // Legacy IDs ('gypsum', 'wood', 'metal') remapped via CEILING_ID_MIGRATION in loadSettings.
  ceilingMaterials: [
    {
      value: "gypsum_plaster",
      label: "Gypsum / Plaster",
      description: "Gypsum board, 1/2-in thick in suspension system",
      absorption: {
        "4000 Hz": 0.09,
        "2000 Hz": 0.07,
        "1000 Hz": 0.04,
        "500 Hz": 0.05,
        "250 Hz": 0.1,
      },
    },
    {
      value: "natural_wood",
      label: "Natural Wood",
      description: "Wood boarding",
      absorption: {
        "4000 Hz": 0.09,
        "2000 Hz": 0.08,
        "1000 Hz": 0.09,
        "500 Hz": 0.1,
        "250 Hz": 0.12,
      },
    },
    {
      value: "concrete",
      label: "Concrete",
      description: "Concrete ceiling",
      absorption: {
        "4000 Hz": 0.03,
        "2000 Hz": 0.02,
        "1000 Hz": 0.02,
        "500 Hz": 0.02,
        "250 Hz": 0.01,
      },
    },
    {
      value: "metal_deck",
      label: "Metal Deck",
      description: "Metal deck",
      absorption: {
        "4000 Hz": 0.02,
        "2000 Hz": 0.07,
        "1000 Hz": 0.1,
        "500 Hz": 0.1,
        "250 Hz": 0.1,
      },
    },
    {
      value: "suspended_ceiling",
      label: "Suspended Ceiling",
      description: "Gypsum board, 1/2-in thick in suspension system",
      absorption: {
        "4000 Hz": 0.09,
        "2000 Hz": 0.07,
        "1000 Hz": 0.04,
        "500 Hz": 0.05,
        "250 Hz": 0.1,
      },
    },
  ],

  // Floor Materials — IDs match docs/acoustic-calculator-sheet-data.yaml (materials.floors).
  // Legacy ID 'wood' remapped via FLOOR_ID_MIGRATION in loadSettings.
  floorMaterials: [
    {
      value: "natural_wood",
      label: "Natural Wood",
      description: "Timber floor on timber joists",
      absorption: {
        "4000 Hz": 0.08,
        "2000 Hz": 0.1,
        "1000 Hz": 0.11,
        "500 Hz": 0.12,
        "250 Hz": 0.11,
      },
    },
    {
      value: "concrete",
      label: "Concrete",
      description: "Concrete floor",
      absorption: {
        "4000 Hz": 0.02,
        "2000 Hz": 0.02,
        "1000 Hz": 0.02,
        "500 Hz": 0.02,
        "250 Hz": 0.01,
      },
    },
    {
      value: "lvt_vinyl",
      label: "LVT / Vinyl on Concrete",
      description: "Linoleum directly on concrete",
      absorption: {
        "4000 Hz": 0.04,
        "2000 Hz": 0.04,
        "1000 Hz": 0.03,
        "500 Hz": 0.03,
        "250 Hz": 0.02,
      },
    },
    {
      value: "cushioned_vinyl",
      label: "Cushioned Vinyl Flooring on Concrete",
      description:
        "Layer of rubber, cork, linoleum+underlay or vinyl+underlay stuck to concrete",
      absorption: {
        "4000 Hz": 0.1,
        "2000 Hz": 0.05,
        "1000 Hz": 0.05,
        "500 Hz": 0.04,
        "250 Hz": 0.02,
      },
    },
    {
      value: "ceramic_tiles",
      label: "Ceramic Tiles",
      description: "Marble or glazed tile",
      absorption: {
        "4000 Hz": 0.02,
        "2000 Hz": 0.02,
        "1000 Hz": 0.01,
        "500 Hz": 0.01,
        "250 Hz": 0.01,
      },
    },
    {
      value: "marble_stone",
      label: "Marble / Stone / Terrazzo",
      description: "Marble, stone, or terrazzo",
      absorption: {
        "4000 Hz": 0.02,
        "2000 Hz": 0.02,
        "1000 Hz": 0.01,
        "500 Hz": 0.01,
        "250 Hz": 0.01,
      },
    },
  ],

  // Floor Coverings (percentage of floor area covered) — separate from floor material.
  // Sheet 4-21-26 exposes only light_carpet; future entries append here.
  // Engine wiring (UI settings keys + multi-covering aggregation) lands in Phase 4.5.
  floorCoverings: [
    {
      value: "light_carpet",
      label: "Light Carpet",
      description: "Carpet, thin, cemented to concrete",
      absorption: {
        "4000 Hz": 0.4,
        "2000 Hz": 0.35,
        "1000 Hz": 0.2,
        "500 Hz": 0.08,
        "250 Hz": 0.04,
      },
    },
  ],

  // Legacy carpet dict — kept for backward compatibility with the current
  // `carpet_type` setting. Engine currently always reads carpetTypes.thin;
  // Phase 4.5 migrates callers onto `floorCoverings` and removes this.
  carpetTypes: {
    thin: {
      label: "Thin carpet",
      description: "Carpet, thin, cemented to concrete",
      absorption: {
        "4000 Hz": 0.4,
        "2000 Hz": 0.35,
        "1000 Hz": 0.2,
        "500 Hz": 0.08,
        "250 Hz": 0.04,
      },
    },
  },

  // Furniture Options
  furnitureOptions: [
    {
      value: "none",
      label: "None",
      floorCoveragePercent: 0,
    },
    {
      value: "partial",
      label: "Partially Furnished",
      floorCoveragePercent: 20,
      description: "Assumes furniture covers 20% of floor area",
    },
    {
      value: "full",
      label: "Fully Furnished",
      floorCoveragePercent: 40,
      description: "Assumes furniture covers 40% of floor area",
    },
  ],

  // Furniture absorption (simplified - uses average values)
  furnitureAbsorption: {
    "4000 Hz": 0.25,
    "2000 Hz": 0.25,
    "1000 Hz": 0.25,
    "500 Hz": 0.25,
    "250 Hz": 0.25,
  },

  // Felt Right Products — IDs match docs/acoustic-calculator-sheet-data.yaml (products.*).
  // Legacy IDs (9mm_2x2, beams, etc.) are remapped via PRODUCT_ID_MIGRATION in loadSettings.
  // Absorption values are per-unit sabins (or coefficient for the 1'×1' tiles).
  feltRightProducts: {
    wall: [
      {
        id: "9mm_felt_2x2",
        name: "9mm Felt Tiles (2' x 2')",
        type: "sabins_per_unit",
        url: "/pages/engraved-tiles",
        image: "ac-product-9mm_felt_2x2.png",
        footprint: 4,
        absorption: {
          "4000 Hz": 3.82,
          "2000 Hz": 2.91,
          "1000 Hz": 1.64,
          "500 Hz": 0.53,
          "250 Hz": 0.13,
        },
      },
      {
        id: "9mm_felt_sheet",
        name: "9mm Felt, Full Sheet (4' x 8')",
        type: "sabins_per_unit",
        footprint: 32,
        url: "/products/commercial-felt-sheet",
        image: "ac-product-9mm_felt_sheet.png",
        absorption: {
          "4000 Hz": 31.18,
          "2000 Hz": 23.79,
          "1000 Hz": 13.38,
          "500 Hz": 4.29,
          "250 Hz": 1.07,
        },
      },
      {
        id: "18mm_felt_2x2",
        name: "18mm Felt Tiles (2' x 2')",
        type: "sabins_per_unit",
        url: "/products/18mm-layered-engraved-2-x-2-tile-tangent?variant=47515750072548",
        image: "ac-product-18mm_felt_2x2.png",
        footprint: 4,
        absorption: {
          "4000 Hz": 4.3,
          "2000 Hz": 4.26,
          "1000 Hz": 3.49,
          "500 Hz": 1.87,
          "250 Hz": 0.54,
        },
      },
      {
        id: "18mm_felt_sheet",
        name: "18mm Felt, Full Sheet (4' x 8')",
        type: "sabins_per_unit",
        footprint: 32,
        url: "/products/18mm-commercial-felt-sheet?variant=47515733983460",
        image: "ac-product-18mm_felt_sheet.png",
        absorption: {
          "4000 Hz": 35.17,
          "2000 Hz": 34.81,
          "1000 Hz": 28.51,
          "500 Hz": 15.24,
          "250 Hz": 4.44,
        },
      },
      {
        id: "apex_2x2",
        name: "Apex Tiles (2' x 2')",
        type: "sabins_per_unit",
        footprint: 4,
        url: "/products/apex-sage",
        image: "ac-product-apex_2x2.png",
        absorption: {
          "4000 Hz": 3.88,
          "2000 Hz": 3.44,
          "1000 Hz": 2.65,
          "500 Hz": 1.6,
          "250 Hz": 0.73,
        },
      },
      {
        id: "peak_2x2",
        name: "Peak Tiles",
        type: "sabins_per_unit",
        footprint: 4,
        url: "/products/peak",
        image: "ac-product-peak_2x2.png",
        absorption: {
          "4000 Hz": 3.88,
          "2000 Hz": 3.44,
          "1000 Hz": 2.65,
          "500 Hz": 1.6,
          "250 Hz": 0.73,
        },
      },
      {
        id: "3d_blocks_set8_12x12x2",
        name: '3D Blocks, Set of 8 (12" x 12" x 2")',
        type: "sabins_per_unit",
        footprint: 8,
        url: "/products/small-3d-acoustic-boxes",
        image: "ac-product-3d_blocks_set8_12x12x2.png",
        absorption: {
          "4000 Hz": 8.92,
          "2000 Hz": 9.34,
          "1000 Hz": 8.91,
          "500 Hz": 6.03,
          "250 Hz": 3.02,
        },
      },
      {
        id: "3d_blocks_set4_12x36x2",
        name: '3D Blocks, Set of 4 (12" x 36" x 2")',
        type: "sabins_per_unit",
        footprint: 12,
        url: "/products/3d-acoustic-boxes-screws",
        image: "ac-product-3d_blocks_set4_12x36x2.png",
        absorption: {
          "4000 Hz": 13.37,
          "2000 Hz": 14.0,
          "1000 Hz": 13.37,
          "500 Hz": 9.05,
          "250 Hz": 4.53,
        },
      },
      {
        id: "3d_blocks_set2_36x36x2",
        name: '3D Blocks, Set of 2 (36" x 36" x 2")',
        type: "sabins_per_unit",
        footprint: 18,
        url: "/products/3d-boxes",
        image: "ac-product-3d_blocks_set2_36x36x2.png",
        absorption: {
          "4000 Hz": 20.05,
          "2000 Hz": 21.0,
          "1000 Hz": 20.04,
          "500 Hz": 13.56,
          "250 Hz": 6.79,
        },
      },
      {
        id: "3d_blocks_set8_12x12x4",
        name: '3D Blocks, Set of 8 (12" x 12" x 4")',
        type: "sabins_per_unit",
        footprint: 8,
        url: "/products/small-3d-acoustic-boxes?variant=47900189720804",
        image: "ac-product-3d_blocks_set8_12x12x4.png",
        absorption: {
          "4000 Hz": 9.65,
          "2000 Hz": 8.87,
          "1000 Hz": 9.95,
          "500 Hz": 9.19,
          "250 Hz": 6.54,
        },
      },
      {
        id: "3d_blocks_set4_12x36x4",
        name: '3D Blocks, Set of 4 (12" x 36" x 4")',
        type: "sabins_per_unit",
        footprint: 12,
        url: "/products/3d-acoustic-boxes-screws?variant=47897001754852",
        image: "ac-product-3d_blocks_set4_12x36x4.png",
        absorption: {
          "4000 Hz": 14.47,
          "2000 Hz": 13.31,
          "1000 Hz": 14.92,
          "500 Hz": 13.78,
          "250 Hz": 9.81,
        },
      },
      {
        id: "3d_blocks_set2_36x36x4",
        name: '3D Blocks, Set of 2 (36" x 36" x 4")',
        type: "sabins_per_unit",
        footprint: 18,
        url: "/products/3d-boxes?variant=47525610193124",
        image: "ac-product-3d_blocks_set2_36x36x4.png",
        absorption: {
          "4000 Hz": 21.71,
          "2000 Hz": 19.96,
          "1000 Hz": 22.37,
          "500 Hz": 20.67,
          "250 Hz": 14.71,
        },
      },
      {
        id: "wood_slat_wall_2pack",
        name: "Wood Slat Wall Panels, 2-Pack",
        type: "sabins_per_unit",
        footprint: 17,
        url: "/products/two-pack-oak-latte-wood-slat-wall",
        image: "ac-product-wood_slat_wall_2pack.png",
        absorption: {
          "4000 Hz": 13.68,
          "2000 Hz": 17.32,
          "1000 Hz": 11.66,
          "500 Hz": 4.44,
          "250 Hz": 1.33,
        },
      },
    ],
    ceiling: [
      {
        id: "3d_clouds_4x4",
        name: "3D Clouds (4' x 4')",
        type: "sabins_per_unit",
        footprint: 16,
        url: "/products/drop-ceiling-cloud-baffle",
        image: "ac-product-3d_clouds_4x4.png",
        absorption: {
          "4000 Hz": 27.2,
          "2000 Hz": 22.85,
          "1000 Hz": 17.29,
          "500 Hz": 13.85,
          "250 Hz": 8.52,
        },
      },
      {
        id: "flat_clouds_2x4",
        name: "Flat Clouds, Set of 2 (2' x 4')",
        type: "sabins_per_unit",
        footprint: 8,
        url: "/products/flat-circle-cloud-baffles",
        image: "ac-product-flat_clouds_2x4.png",
        absorption: {
          "4000 Hz": 14.77,
          "2000 Hz": 14.03,
          "1000 Hz": 11.01,
          "500 Hz": 7.74,
          "250 Hz": 5.11,
        },
      },
      {
        id: "blades_12oc",
        name: "Blades, Set of 2, 12\" on center (8' x 1')",
        type: "sabins_per_unit",
        footprint: 8,
        url: "/products/admiral-ceiling-blade",
        image: "ac-product-blades_12oc.png",
        absorption: {
          "4000 Hz": 11.58,
          "2000 Hz": 9.85,
          "1000 Hz": 6.72,
          "500 Hz": 4.89,
          "250 Hz": 2.96,
        },
      },
      {
        id: "beams_12oc",
        name: "Beams, Set of 2, 12\" on center (8')",
        type: "sabins_per_unit",
        footprint: 8,
        url: "/products/4-foot-wood-acoustic-beams",
        image: "ac-product-beams_12oc.png",
        absorption: {
          "4000 Hz": 12.11,
          "2000 Hz": 11.55,
          "1000 Hz": 9.22,
          "500 Hz": 6.63,
          "250 Hz": 3.16,
        },
      },
      {
        id: "wood_slat_ceiling_2x2",
        name: "Wood Slat Ceiling Tiles (2' x 2')",
        type: "sabins_per_unit",
        footprint: 4,
        url: "/products/walnut-wood-slat-ceiling",
        image: "ac-product-wood_slat_ceiling_2x2.png",
        absorption: {
          "4000 Hz": 3.45,
          "2000 Hz": 3.62,
          "1000 Hz": 3.34,
          "500 Hz": 2.99,
          "250 Hz": 3.71,
        },
      },
    ],

    // Unlisted / large-format variants — not offered in the standard dropdown,
    // sourced via custom quotes. Listed here for Phase 6 super-user mode and
    // for parity with the sheet catalog. Room-divider also exposed via
    // `roomDivider` below for engine compatibility.
    unlisted: [
      {
        id: "room_divider_47x95",
        name: 'Room Divider (47.75" x 95.75")',
        type: "sabins_per_unit",
        footprint: 31.75043403,
        url: "/products/dash-partition",
        absorption: {
          "4000 Hz": 42.66,
          "2000 Hz": 41.38,
          "1000 Hz": 33.96,
          "500 Hz": 28.03,
          "250 Hz": 23.7,
        },
      },
      {
        id: "9mm_felt_107x95",
        name: '9mm PET Felt (107" x 95")',
        type: "sabins_per_unit",
        footprint: 70.59,
        absorption: {
          "4000 Hz": 68.78,
          "2000 Hz": 52.48,
          "1000 Hz": 29.51,
          "500 Hz": 9.47,
          "250 Hz": 2.37,
        },
      },
      {
        id: "18mm_felt_107x95",
        name: '18mm PET Felt (107" x 95")',
        type: "sabins_per_unit",
        footprint: 70.59,
        absorption: {
          "4000 Hz": 77.58,
          "2000 Hz": 76.78,
          "1000 Hz": 62.89,
          "500 Hz": 33.62,
          "250 Hz": 9.79,
        },
      },
      {
        id: "3d_tiles_118x95",
        name: '3D Tiles (118.75" x 95")',
        type: "sabins_per_unit",
        footprint: 78.34,
        absorption: {
          "4000 Hz": 77.63,
          "2000 Hz": 68.84,
          "1000 Hz": 52.9,
          "500 Hz": 32.05,
          "250 Hz": 14.63,
        },
      },
      {
        id: "3d_blocks_107x95_2",
        name: '3D Blocks, 2" depth (107.625" x 95.625")',
        type: "sabins_per_unit",
        footprint: 71.47,
        absorption: {
          "4000 Hz": 81.27,
          "2000 Hz": 85.11,
          "1000 Hz": 81.24,
          "500 Hz": 54.98,
          "250 Hz": 27.53,
        },
      },
      {
        id: "3d_blocks_107x95_4",
        name: '3D Blocks, 4" depth (107.625" x 95.625")',
        type: "sabins_per_unit",
        footprint: 71.47,
        absorption: {
          "4000 Hz": 87.98,
          "2000 Hz": 80.89,
          "1000 Hz": 90.67,
          "500 Hz": 83.77,
          "250 Hz": 59.63,
        },
      },
      {
        id: "wood_slat_wall_108x94",
        name: 'Wood Slat Wall Panels (108.125" x 94.5")',
        type: "sabins_per_unit",
        footprint: 70.96,
        absorption: {
          "4000 Hz": 59.13,
          "2000 Hz": 74.87,
          "1000 Hz": 50.39,
          "500 Hz": 19.17,
          "250 Hz": 5.75,
        },
      },
      {
        id: "wood_slat_ceiling_108x94",
        name: 'Wood Slat Ceiling Tiles (108.125" x 94.5")',
        type: "sabins_per_unit",
        footprint: 70.96,
        absorption: {
          "4000 Hz": 63.15,
          "2000 Hz": 66.17,
          "1000 Hz": 61.09,
          "500 Hz": 54.65,
          "250 Hz": 67.91,
        },
      },
    ],
  },

  // Room Divider product (commercial only)
  roomDivider: {
    name: 'Room Divider (47.75" x 95.75")',
    footprint: 31.75043403,
    sheetArea: 32,
    url: "/products/dash-partition",
    absorption: {
      "4000 Hz": 42.66,
      "2000 Hz": 41.38,
      "1000 Hz": 33.96,
      "500 Hz": 28.03,
      "250 Hz": 23.7,
    },
  },

  // Open entryway absorption (constant across frequencies)
  openEntrywayAbsorption: {
    "4000 Hz": 0.5,
    "2000 Hz": 0.5,
    "1000 Hz": 0.5,
    "500 Hz": 0.5,
    "250 Hz": 0.5,
  },

  // Room volume effects (per 1000 ft³)
  roomVolumeEffects: {
    "4000 Hz": 7, // 84 sabins per 12000 ft³
    "2000 Hz": 3, // 36 sabins per 12000 ft³
    "1000 Hz": 1.2, // 14.4 sabins per 12000 ft³
    "500 Hz": 0,
    "250 Hz": 0,
  },

  // Constants
  maxVolumeLimit: 35000,

  // Disclaimers and warnings
  disclaimers: {
    main: "This calculator is designed for rectangular rooms with standard building materials. More complex spaces will need individual attention from an expert. This includes: rooms where listening is critical (sound mixing rooms, etc.), spaces that are greater than 35,000 cubic feet, spaces that are largely open to each other, rooms with unusual building materials, and spaces with unusual shapes, like curved walls. If your space fits any of these descriptions, please contact us for a free consultation.",
    soundTransfer:
      "If you have issues with sound transferring from other rooms, contact us for a free consultation.",
  },

  warnings: {
    criticalAudio: {
      condition: (roomTypes) => roomTypes.includes("critical_audio"),
      message:
        "This calculator is not designed for rooms in need of low frequency (bass) acoustic treatment. If your room is used for critical audio recording and/or listening, please contact us for a free consultation.",
    },
    mechanicalNoise: {
      message:
        "This type of space may have significant mechanical noise sources (HVAC, machinery, etc.) that affect acoustic performance. The calculator estimates reverberation only — contact us for a comprehensive assessment.",
    },
    highCeiling: {
      condition: (height) => height > 12,
      message:
        "For rooms with ceilings over 12 feet high, avoid placing all of the acoustic treatment on the ceiling. Instead, consider a solution that includes either Felt Right wall products or Felt Right ceiling products hung below the 12-foot mark.",
    },
    largeRoom: {
      condition: (volume) => volume > 35000,
      message:
        "Rooms over 35,000 cubic feet may have unique acoustic problems related to room geometry or other special features of the space. Before placing a large order, we recommend contacting Felt Right for a review of the space and its acoustic requirements.",
    },
    exceededSpace: {
      condition: (wallNeeded, wallAvailable, ceilingNeeded, ceilingAvailable) =>
        wallNeeded > wallAvailable || ceilingNeeded > ceilingAvailable,
      message:
        "One or more of the recommended solutions exceeds your available space. Try making more wall or ceiling space available, adding Felt Right Room Dividers, or choosing alternative Felt Right products which may require less space. Contact us if you still need help.",
    },
    inadequateAbsorption: {
      message:
        "Your selected Felt Right products may not provide adequate absorption for this space. Try selecting higher-NRC Felt Right products, or contact us for more information.",
    },
  },

  // Output explanations from CSV
  explanations: {
    standard:
      "Felt Right products at this level should tame the mid to upper end of the vocal range (500 Hz and above at a minimum). You can expect great intelligibility and reduced reverberation.",
    acceptable:
      "This space may have acceptable acoustics for your intended use. Felt Right products may still help if the room doesn't sound quite right. For example, adding localized sound treatment to key work areas. Contact us for more information.",
  },

  // Default settings
  defaultSettings: {
    // Room types (can select multiple)
    selectedRoomTypes: [],

    // Room dimensions
    room_length: 30,
    room_width: 40,
    room_height: 10,

    // Materials
    wall_material: "gypsum_plaster",
    ceiling_material: "metal_deck",
    floor_material: "concrete",

    // Coverage percentages
    carpeting_percentage: 0,
    available_wall_space: 40, // percentage
    available_ceiling_space: 70, // percentage

    // Other inputs
    open_entryways: 0,
    furniture: "partial",

    // Product selections
    wall_product: "9mm_felt_2x2",
    ceiling_product: "beams_12oc",

    // Calculation mode
    solution_preference: "balanced", // 'walls_first', 'balanced', 'ceiling_first'
  },

  // Thresholds per 4-21-26 sheet
  thresholds: {
    large_room_volume_ft3: 50000,
    contact_sales_volume_ft3: 35000,
    high_ceiling_ft: 12,
    inadequate_250_ratio: 1.5,
  },

  // Building-type dropdown order (sheet: "4-21-26 Calculator" tab)
  buildingTypes: [
    "Business/Corporate",
    "Education",
    "Hospitality",
    "Sports/Fitness",
    "Recording Studio",
    "Church",
    "Industrial",
    "Residential",
    "Clinic/Healthcare",
  ],

  // Room-type lookup table — 52 rows from docs/acoustic-calculator-sheet-data.yaml.
  // Replaces the legacy log-formula roomTypes archetypes. `building`+`room` is the key.
  // `target_rt60` applies when roomVolume <= thresholds.large_room_volume_ft3;
  // `lg_room_target_rt60` applies above that.
  ROOM_TYPES: [
    // Business/Corporate
    {
      building: "Business/Corporate",
      room: "Open Office",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 0.81,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Business/Corporate",
      room: "Call Center",
      archetype: "theater_conf_avg",
      target_rt60: 0.93,
      lg_room_target_rt60: 0.74,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Business/Corporate",
      room: "Private Office",
      archetype: "conf_lecture",
      target_rt60: 0.84,
      lg_room_target_rt60: 0.84,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Business/Corporate",
      room: "Conference Room",
      archetype: "conf_lecture",
      target_rt60: 0.84,
      lg_room_target_rt60: 0.84,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Business/Corporate",
      room: "Shared Office/Huddle Room",
      archetype: "conf_lecture",
      target_rt60: 0.84,
      lg_room_target_rt60: 0.84,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Business/Corporate",
      room: "Reception Area/Lobby",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 1.19,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Business/Corporate",
      room: "Breakroom",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 0.81,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Business/Corporate",
      room: "Cafeteria",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 0.81,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },

    // Education
    {
      building: "Education",
      room: "Classroom - Grades K-8",
      archetype: "ansi_classroom",
      target_rt60: 0.6,
      lg_room_target_rt60: 0.7,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Education",
      room: "Classroom - Grades 9-12",
      archetype: "conf_lecture",
      target_rt60: 0.84,
      lg_room_target_rt60: 0.84,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Education",
      room: "Classroom/Lecture Hall - College/University",
      archetype: "conf_lecture",
      target_rt60: 0.84,
      lg_room_target_rt60: 0.84,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Education",
      room: "Cafeteria",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 0.81,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Education",
      room: "Gymnasium",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 0.96,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Education",
      room: "Auditorium",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 0.96,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Education",
      room: "Music Rehearsal Room",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 0.81,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },

    // Hospitality
    {
      building: "Hospitality",
      room: "Restaurant",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 0.81,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Hospitality",
      room: "Bar/Lounge",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 0.96,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Hospitality",
      room: "Bar with Live Music",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 0.81,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Hospitality",
      room: "Private Dining Room",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 1.01,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Hospitality",
      room: "Event Space/Banquet Hall",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 0.96,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Hospitality",
      room: "Salon/Barber Shop",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 1.19,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Hospitality",
      room: "Spa/Wellness Center",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 1.01,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Hospitality",
      room: "Hotel Lobby",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 1.19,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Hospitality",
      room: "Hotel Room",
      archetype: "conf_lecture",
      target_rt60: 0.84,
      lg_room_target_rt60: 0.84,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },

    // Sports/Fitness
    {
      building: "Sports/Fitness",
      room: "General Fitness Center",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 0.96,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Sports/Fitness",
      room: "Weight Room",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 0.96,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Sports/Fitness",
      room: "Gymnasium/Sports Court",
      archetype: "concert_hall",
      target_rt60: 1.34,
      lg_room_target_rt60: 1.07,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Sports/Fitness",
      room: "Yoga Studio",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 1.01,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Sports/Fitness",
      room: "Pilates/Barre/Dance Studio",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 1.01,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Sports/Fitness",
      room: "Group Fitness Studio",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 1.19,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Sports/Fitness",
      room: "Swimming Pool",
      archetype: "concert_hall",
      target_rt60: 1.34,
      lg_room_target_rt60: 1.07,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Sports/Fitness",
      room: "Locker Room",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 1.19,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },

    // Recording Studio
    {
      building: "Recording Studio",
      room: "Podcast Studio",
      archetype: "recording_studio",
      target_rt60: 0.63,
      lg_room_target_rt60: 0.63,
      sound_source: "normal",
      critical_audio: true,
      mechanical_noise: false,
    },
    {
      building: "Recording Studio",
      room: "Music Studio - Control Room",
      archetype: "recording_studio",
      target_rt60: 0.63,
      lg_room_target_rt60: 0.63,
      sound_source: "normal",
      critical_audio: true,
      mechanical_noise: false,
    },
    {
      building: "Recording Studio",
      room: "Music Studio - Live Room",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 0.81,
      sound_source: "loud",
      critical_audio: true,
      mechanical_noise: false,
    },

    // Church
    {
      building: "Church",
      room: "Chapel",
      archetype: "concert_hall",
      target_rt60: 1.34,
      lg_room_target_rt60: 1.34,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Church",
      room: "Cathedral",
      archetype: "church_choral",
      target_rt60: 1.43,
      lg_room_target_rt60: 1.43,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Church",
      room: "Event Space",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 0.81,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },

    // Industrial
    {
      building: "Industrial",
      room: "Manufacturing Facility",
      archetype: "concert_hall",
      target_rt60: 1.34,
      lg_room_target_rt60: 1.07,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: true,
    },
    {
      building: "Industrial",
      room: "Warehouse",
      archetype: "concert_hall",
      target_rt60: 1.34,
      lg_room_target_rt60: 1.34,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: true,
    },
    {
      building: "Industrial",
      room: "Distribution Center",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 1.19,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: true,
    },

    // Residential
    {
      building: "Residential",
      room: "Kitchen",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 1.01,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Residential",
      room: "Living Room/Great Room",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 1.01,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Residential",
      room: "Home Theater",
      archetype: "recording_studio",
      target_rt60: 0.63,
      lg_room_target_rt60: 0.63,
      sound_source: "normal",
      critical_audio: true,
      mechanical_noise: false,
    },
    {
      building: "Residential",
      room: "Home Office",
      archetype: "conf_lecture",
      target_rt60: 0.84,
      lg_room_target_rt60: 0.84,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Residential",
      room: "Workshop/Garage",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 0.96,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Residential",
      room: "Home Gym",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 1.01,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },

    // Clinic/Healthcare
    {
      building: "Clinic/Healthcare",
      room: "Inpatient/Resident Room",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 1.01,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Clinic/Healthcare",
      room: "Inpatient/Resident Common Area",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 1.19,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Clinic/Healthcare",
      room: "General Treatment Room",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 1.01,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Clinic/Healthcare",
      room: "Reception/Waiting Area",
      archetype: "church_speech",
      target_rt60: 1.19,
      lg_room_target_rt60: 1.19,
      sound_source: "normal",
      critical_audio: false,
      mechanical_noise: false,
    },
    {
      building: "Clinic/Healthcare",
      room: "Dental Office",
      archetype: "theater",
      target_rt60: 1.01,
      lg_room_target_rt60: 0.81,
      sound_source: "loud",
      critical_audio: false,
      mechanical_noise: true,
    },
  ],

  CRITICAL_AUDIO_ROOMS: [
    "Podcast Studio",
    "Music Studio - Control Room",
    "Music Studio - Live Room",
    "Home Theater",
  ],

  MECHANICAL_NOISE_ROOMS: [
    "Manufacturing Facility",
    "Warehouse",
    "Distribution Center",
    "Dental Office",
  ],

  // D3-locked default: UI falls back to these when building/room are unset.
  defaultBuildingRoom: {
    building: "Business/Corporate",
    room: "Open Office",
  },

  PRESETS: [
    {
      label: "Industrial - Distribution Center",
      building: "Industrial",
      room: "Distribution Center",
      room_length: 40,
      room_width: 50,
      room_height: 12,
      walls: [
        { material_id: "gypsum_plaster" },
        { material_id: "gypsum_plaster" },
        { material_id: "gypsum_plaster" },
        { material_id: "gypsum_plaster" },
      ],
      ceiling_material: "metal_deck",
      floor_material: "natural_wood",
      room_divider_quantity: 1,
      open_entryways: 6,
      available_wall_space: 60,
      available_ceiling_space: 60,
      furniture: "partial",
    },
    {
      label: "Education - Classroom 9-12",
      building: "Education",
      room: "Classroom - Grades 9-12",
      room_length: 20,
      room_width: 10,
      room_height: 10,
      walls: [
        { material_id: "gypsum_plaster" },
        { material_id: "gypsum_plaster" },
        { material_id: "gypsum_plaster" },
        { material_id: "gypsum_plaster" },
      ],
      ceiling_material: "suspended_ceiling",
      floor_material: "lvt_vinyl",
      room_divider_quantity: 0,
      open_entryways: 0,
      available_wall_space: 60,
      available_ceiling_space: 60,
      furniture: "partial",
    },
    {
      label: "Church - Cathedral",
      building: "Church",
      room: "Cathedral",
      room_length: 70,
      room_width: 60,
      room_height: 36,
      walls: [
        { material_id: "gypsum_plaster" },
        { material_id: "gypsum_plaster" },
        { material_id: "brick" },
        { material_id: "brick" },
      ],
      ceiling_material: "natural_wood",
      floor_material: "marble_stone",
      room_divider_quantity: 0,
      open_entryways: 0,
      available_wall_space: 60,
      available_ceiling_space: 60,
      furniture: "partial",
    },
    {
      label: "Sports/Fitness - Swimming Pool",
      building: "Sports/Fitness",
      room: "Swimming Pool",
      room_length: 100,
      room_width: 80,
      room_height: 32,
      walls: [
        { material_id: "concrete_block" },
        { material_id: "concrete_block" },
        { material_id: "concrete_block" },
        { material_id: "concrete_block" },
      ],
      ceiling_material: "concrete",
      floor_material: "ceramic_tiles",
      room_divider_quantity: 0,
      open_entryways: 0,
      available_wall_space: 60,
      available_ceiling_space: 60,
      furniture: "none",
    },
  ],
};
